
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4f3b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4f3b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ehwiP", function(module, exports) {

$parcel$export(module.exports, "register", () => $a65bb5d5f300e762$export$6503ec6e8aabbaf, (v) => $a65bb5d5f300e762$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $a65bb5d5f300e762$export$f7ad0328861e2f03, (v) => $a65bb5d5f300e762$export$f7ad0328861e2f03 = v);
var $a65bb5d5f300e762$export$6503ec6e8aabbaf;
var $a65bb5d5f300e762$export$f7ad0328861e2f03;
"use strict";
var $a65bb5d5f300e762$var$mapping = new Map();
function $a65bb5d5f300e762$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$a65bb5d5f300e762$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $a65bb5d5f300e762$var$resolve(id) {
    var resolved = $a65bb5d5f300e762$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$a65bb5d5f300e762$export$6503ec6e8aabbaf = $a65bb5d5f300e762$var$register;
$a65bb5d5f300e762$export$f7ad0328861e2f03 = $a65bb5d5f300e762$var$resolve;

});

var $127b95c152e60649$exports = {};

(parcelRequire("ehwiP")).register(new URL("", import.meta.url).toString(), JSON.parse('["f6R1R","index.f6995173.js","kGTAZ","privacy_policy.6a4402e6.pdf","2AhY8","unika_checkup_terms.f5be80a6.pdf","hsy2u","unika_logo_white.becc4144.svg","6r5tl","opengraph.5f349a18.png","eFPTp","bankid.5093793f.svg","8MJVW","amtrust.6e556d0e.pdf","961Zv","company.c4c74684.pdf","4UTlr","product.0e5aa888.png","ku3mG","doctor_paper.fc51809f.svg","cd0x4","doctor_scanner.69088a58.svg","4Pg3P","doctor_table.630f697f.svg","ly0O4","doctor_xray.1f99174f.svg","kNtLk","faktablad-preview.0318d883.png","6djPL","faktablad2023.f42c9068.pdf","2UiKX","purchaseinfo-preview.c61f1ddc.png","aEFK2","purchaseinfo2023.a391ce6e.pdf","kt7ls","villkor-preview.5488efa9.png","eEPYm","villkor2023.599b669e.pdf","EIQwd","GrowLottie.b50e549c.js","gaRih","27-globe-outline-unika.a58abad9.js","5VaEY","27-globe-outline-white.8197fe8e.js","byWxn","about-optimised.220d5bd0.m4v","3ZCWq","about.99844b30.png","ii0kw","bankid_white.cf45bc47.svg","7zqrx","Agreement.f923eccf.js","d2zS5","agreement.37616ef5.js","4fQKc","bankgirot.4932c150.svg","7xcXe","trustly.fd2c4159.svg","4RMoP","Faktablad.bfacdb56.js","aYKBm","eiopa-area.4c687852.svg","7by7E","eiopa-cancellation.3ea93e34.svg","4govA","eiopa-duration.eeffb63e.svg","8hIIa","eiopa-important.d86c4ad2.svg","g214Q","eiopa-included.f4d15c58.svg","l4aXo","eiopa-not-included.9fd892dd.svg","9ldCk","eiopa-obligations.2e6437fe.svg","kMuwN","eiopa-price.46fe45d8.svg","4fbli","Letter.34c07201.js","kqIqz","erik-vd-signature.1043f8e7.svg","5L7PG","PurchaseInfo.5c686e54.js","dF1mm","axeria.313a4fc6.png","bI2DI","further.4835b0be.png","5D7nb","unika_logo_pinguin.bb34fa84.svg","5INpe","Referral.e2125543.js","hfoH1","About.fab14045.js","bSs5q","20-love-heart-outline-unika.1a95f37e.js","c8Qcx","20-love-heart-outline-white.02204ded.js","aQPXX","BrokerSignup.13aea26e.js","bYyvm","CheckupOrder.8f57c77e.js","4VxGH","Contacts.d3e05220.js","5rIff","Admin.21685b80.js","9JqkD","Profile.3dab3a32.js","jQMCy","Broker.f736e0bd.js","frM9G","BrokerAgreement.064cd86c.js","2mMPD","BrokerChild.204e69c6.js","5LxWc","BrokerCoinsured.8bf861c0.js","lJdL7","Employee.aeb3f3ee.js","aqcqo","Group.73552fc3.js","KDXIL","TermsAndConditions.e044f91e.js","1WwMR","index.72d32ff3.css"]'));


//# sourceMappingURL=index.runtime.3bcd5912.js.map
